import { Action, createReducer, on } from '@ngrx/store';

// Actions
import * as TaskDataActions from './taskData.actions';

// States
import {
    TasksState, TaskStatusesState, TaskCategoriesState, TaskModulesState, AccountNamesState, LeadNamesState, OpportunityNamesState,
    CaseNamesState, ReminderTypesState
} from './taskData.state';

export const initialState = [];

// Reducer for Tasks
const tasksReducer = createReducer(
    initialState,
    on(TaskDataActions.getTasks, state => state),
    on(TaskDataActions.successGetTasks, (state: TasksState[], { payload }) => payload),
    on(TaskDataActions.errorTasks, (state: TasksState[], error: Error) => { return { ...state, error } })
);

export function TasksReducer(state: TasksState[] | [], action: Action) {
    return tasksReducer(state, action);
}

// Reducer for Task Statuses
const tasksStatusesReducer = createReducer(
    initialState,
    on(TaskDataActions.getTaskStatuses, state => state),
    on(TaskDataActions.successGetTaskStatuses, (state: TaskStatusesState[], { payload }) => payload),
    on(TaskDataActions.errorTaskStatuses, (state: TaskStatusesState[], error: Error) => { return { ...state, error } })
);

export function TaskStatusesReducer(state: TaskStatusesState[] | [], action: Action) {
    return tasksStatusesReducer(state, action);
}

// Reducer for Task Categories
const tasksCategoriesReducer = createReducer(
    initialState,
    on(TaskDataActions.getTaskCategories, state => state),
    on(TaskDataActions.successGetTaskCategories, (state: TaskCategoriesState[], { payload }) => payload),
    on(TaskDataActions.errorTaskCategories, (state: TaskCategoriesState[], error: Error) => { return { ...state, error } })
);

export function TaskCategoriesReducer(state: TaskCategoriesState[] | [], action: Action) {
    return tasksCategoriesReducer(state, action);
}

// Reducer for Task Modules
const tasksModulesReducer = createReducer(
    initialState,
    on(TaskDataActions.getTaskModules, state => state),
    on(TaskDataActions.successGetTaskModules, (state: TaskModulesState[], { payload }) => payload),
    on(TaskDataActions.errorTaskModules, (state: TaskModulesState[], error: Error) => { return { ...state, error } })
);

export function TaskModulesReducer(state: TaskModulesState[] | [], action: Action) {
    return tasksModulesReducer(state, action);
}

// Reducer for Account Names
const accountNamesReducer = createReducer(
    initialState,
    on(TaskDataActions.getAccountNames, state => state),
    on(TaskDataActions.successGetAccountNames, (state: AccountNamesState[], { payload }) => payload),
    on(TaskDataActions.errorAccountNames, (state: AccountNamesState[], error: Error) => { return { ...state, error } })
);

export function AccountNamesReducer(state: AccountNamesState[] | [], action: Action) {
    return accountNamesReducer(state, action);
}

// Reducer for Lead Names
const leadNamesReducer = createReducer(
    initialState,
    on(TaskDataActions.getLeadNames, state => state),
    on(TaskDataActions.successGetLeadNames, (state: LeadNamesState[], { payload }) => payload),
    on(TaskDataActions.errorLeadNames, (state: LeadNamesState[], error: Error) => { return { ...state, error } })
);

export function LeadNamesReducer(state: LeadNamesState[] | [], action: Action) {
    return leadNamesReducer(state, action);
}

// Reducer for Opportunity Names
const opportunityNamesReducer = createReducer(
    initialState,
    on(TaskDataActions.getOpportunityNames, state => state),
    on(TaskDataActions.successGetOpportunityNames, (state: OpportunityNamesState[], { payload }) => payload),
    on(TaskDataActions.errorOpportunityNames, (state: OpportunityNamesState[], error: Error) => { return { ...state, error } })
);

export function OpportunityNamesReducer(state: OpportunityNamesState[] | [], action: Action) {
    return opportunityNamesReducer(state, action);
}

// Reducer for Case Names
const caseNamesReducer = createReducer(
    initialState,
    on(TaskDataActions.getCaseNames, state => state),
    on(TaskDataActions.successGetCaseNames, (state: CaseNamesState[], { payload }) => payload),
    on(TaskDataActions.errorCaseNames, (state: CaseNamesState[], error: Error) => { return { ...state, error } })
);

export function CaseNamesReducer(state: CaseNamesState[] | [], action: Action) {
    return caseNamesReducer(state, action);
}

// Reducer for Reminder Types
const reminderTypesReducer = createReducer(
    initialState,
    on(TaskDataActions.getReminderTypes, state => state),
    on(TaskDataActions.successGetReminderTypes, (state: ReminderTypesState[], { payload }) => payload),
    on(TaskDataActions.errorReminderTypes, (state: ReminderTypesState[], error: Error) => { return { ...state, error } })
);

export function ReminderTypesReducer(state: ReminderTypesState[] | [], action: Action) {
    return reminderTypesReducer(state, action);
}